/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CacheMonitorControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCacheStats(): CancelablePromise<Record<string, Record<string, any>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/cache/stats',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public getSpecificCacheEntryStats({
        cacheName,
        key,
    }: {
        cacheName: string,
        key: string,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/cache/stats/{cacheName}/entry/{key}',
            path: {
                'cacheName': cacheName,
                'key': key,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public clearSpecificCacheEntry({
        cacheName,
        key,
    }: {
        cacheName: string,
        key: string,
    }): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/cache/{cacheName}/entry/{key}',
            path: {
                'cacheName': cacheName,
                'key': key,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public clearSpecificCache({
        cacheName,
    }: {
        cacheName: string,
    }): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/cache/{cacheName}/clear',
            path: {
                'cacheName': cacheName,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public clearAllCaches(): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/cache/clear',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
